import axiosMapInstance from "../interceptor/webMapInstance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/config`;

export const getOperatorsByQuarter = async (data) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/${data.countryCode}/${data.quarter}%20${data.year}`
  );
  return response.data;
};

export const getMapGlobalConfig = async (countryCode) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/global/${countryCode}`
  );
  return response.data;
}
